import axios from 'axios'
export default class InvoiceService {
  static getURL (complement = '') {
    return `${process.env.VUE_APP_INVOICING_API}${complement}`
  }

  static async listInvoices (body) {
    const url = await this.getURL('/cfdi/getAll')
    const { data } = await axios.post(url, body)
    return data
  }

  static async downloadInvoiceByID (params) {
    const url = await this.getURL(`/cfdi/${params.fileType}/issuedLite/${params.id}`)
    const { data } = await axios.get(url)
    return data
  }
}
